import axios from "axios";

const endpoint = process.env.REACT_APP_API_URL;

export const FETCH_LOGIN_BEGIN = "FETCH_LOGIN_BEGIN";
export const FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS";
export const FETCH_LOGIN_FAILURE = "FETCH_LOGIN_FAILURE";

export const FETCH_CONFIRM_RESET_PASSWORD_BEGIN =
  "FETCH_CONFIRM_RESET_PASSWORD_BEGIN";
export const FETCH_CONFIRM_RESET_PASSWORD_SUCCESS =
  "FETCH_CONFIRM_RESET_PASSWORD_SUCCESS";
export const FETCH_CONFIRM_RESET_PASSWORD_FAILURE =
  "FETCH_CONFIRM_RESET_PASSWORD_FAILURE";

export const FETCH_RESET_PASSWORD_BEGIN = "FETCH_RESET_PASSWORD_BEGIN";
export const FETCH_RESET_PASSWORD_SUCCESS = "FETCH_RESET_PASSWORD_SUCCESS";
export const FETCH_RESET_PASSWORD_FAILURE = "FETCH_RESET_PASSWORD_FAILURE";

export const FETCH_USERS_BEGIN = "FETCH_USERS_BEGIN";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";

export const FETCH_USER_BEGIN = "FETCH_USER_BEGIN";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";

export const DELETE_USER_BEGIN = "DELETE_USER_BEGIN";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

export const LOG_USER_OUT = "LOG_USER_OUT";

export const fetchLoginBegin = () => ({
  type: FETCH_LOGIN_BEGIN,
});

export const fetchLoginSuccess = (user) => ({
  type: FETCH_LOGIN_SUCCESS,
  payload: user,
});

export const fetchLoginFailure = (error) => ({
  type: FETCH_LOGIN_FAILURE,
  payload: { error },
});

export const fetchConfirmResetPasswordBegin = () => ({
  type: FETCH_CONFIRM_RESET_PASSWORD_BEGIN,
});

export const fetchConfirmResetPasswordSuccess = () => ({
  type: FETCH_CONFIRM_RESET_PASSWORD_SUCCESS,
});

export const fetchConfirmResetPasswordFailure = (error) => ({
  type: FETCH_CONFIRM_RESET_PASSWORD_FAILURE,
  payload: { error },
});

export const fetchResetPasswordBegin = () => ({
  type: FETCH_RESET_PASSWORD_BEGIN,
});

export const fetchResetPasswordSuccess = () => ({
  type: FETCH_RESET_PASSWORD_SUCCESS,
});

export const fetchResetPasswordFailure = (error) => ({
  type: FETCH_RESET_PASSWORD_FAILURE,
  payload: { error },
});

export const fetchUsersBegin = () => ({
  type: FETCH_USERS_BEGIN,
});

export const fetchUsersSuccess = (token) => ({
  type: FETCH_USERS_SUCCESS,
  payload: token,
});

export const fetchUsersFailure = (error) => ({
  type: FETCH_USERS_FAILURE,
  payload: { error },
});

export const fetchUserBegin = () => ({
  type: FETCH_USER_BEGIN,
});

export const fetchUserSuccess = (token) => ({
  type: FETCH_USER_SUCCESS,
  payload: token,
});

export const fetchUserFailure = (error) => ({
  type: FETCH_USER_FAILURE,
  payload: { error },
});

export const deleteUserBegin = () => ({
  type: DELETE_USER_BEGIN,
});

export const deleteUserSuccess = () => ({
  type: DELETE_USER_SUCCESS,
});

export const deleteUserFailure = (error) => ({
  type: DELETE_USER_FAILURE,
  payload: { error },
});

export const logUserOut = () => ({
  type: LOG_USER_OUT,
});

export const createUser = async (user) => {
  const created = await axios.post(`${endpoint}/users`, user);

  if (created.status !== 200) {
    throw new Error("Failed to create user");
  }
  return created;
};

export const getUsers = async () => {
  return async (dispatch) => {
    dispatch(fetchUsersBegin());
    try {
      const users = await axios.get(`${endpoint}/users`);
      dispatch(fetchUsersSuccess(users.data));
    } catch (err) {
      dispatch(fetchUsersFailure("Failed to fetch users"));
    }
  };
};

export const getUser = async (userId) => {
  return async (dispatch) => {
    dispatch(fetchUserBegin());
    try {
      const users = await axios.get(`${endpoint}/users/${userId}`);
      dispatch(fetchUserSuccess(users.data));
    } catch (err) {
      dispatch(fetchUserFailure("Failed to fetch users"));
    }
  };
};

export const deleteUser = async (userId) => {
  return async (dispatch) => {
    try {
      await axios.delete(`${endpoint}/users/${userId}`);
      dispatch(deleteUserSuccess());
      dispatch(await getUsers());
    } catch (err) {
      dispatch(deleteUserFailure("Failed to delete user"));
    }
  }
}

export const login = async (email, password) => {
  return async (dispatch) => {
    dispatch(fetchLoginBegin());
    try {
      const user = await axios.post(`${endpoint}/signin`, { email, password });
      if (user.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(user.data));
        dispatch(fetchLoginSuccess(user.data));
      }
    } catch (err) {
      dispatch(fetchLoginFailure("Failed to login"));
    }
  };
};

export const logout = () => {
  return (dispatch) => {
    localStorage.removeItem("user");
    dispatch(logUserOut());
  };
};

export const resetPassword = (email) => {
  return async (dispatch) => {
    dispatch(fetchResetPasswordBegin());
    try {
      await axios.post(`${endpoint}/passwordreset`, { email });
      dispatch(fetchResetPasswordSuccess());
    } catch (err) {
      dispatch(fetchResetPasswordFailure());
    }
  };
};

export const confirmResetPassword = (userId, token, password) => {
  return async (dispatch) => {
    dispatch(fetchConfirmResetPasswordBegin());
    try {
      await axios.post(`${endpoint}/passwordreset/confirm`, {
        userId,
        token,
        password,
      });
      dispatch(fetchConfirmResetPasswordSuccess());
    } catch (err) {
      dispatch(fetchConfirmResetPasswordFailure());
    }
  };
};

export const updateUser = async (id, update) => {
  const updated = await axios.patch(`${endpoint}/users/${id}`, update);

  if (updated.status !== 200) {
    throw new Error("Failed to update user");
  }
  return updated;
};
